import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomForm from "../../../components/CustomForm/CustomForm";
import { adminRequest } from "../../../utils/requestMethods";
import { BASE_URL } from "../../../utils/config";
import Loader from "../../../components/Loader/Loader";
const EditRoutine = () => {
  const location = useLocation();
  const activeURL = location.pathname.split("/")[4];
  const initialFormData = {
    subject: "",
    program: "",
    semester: "",
    day: "",
    timeSlotId: "",
    room: "",
    facultyId: "",
  };

  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialFormData);
  const [data, setData] = useState(initialFormData);
  const [program, setProgram] = useState([]);
  const [semester, setSemester] = useState([]);
  const [subject, setSubject] = useState([]);
  const [faculty, setFaculty] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchProgram = async () => {
      try {
        const response = await adminRequest.get(
          `${BASE_URL}/course/getNameAndId`,
        );
        setProgram(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    if (formData.program) {
      const fetchSemester = async () => {
        try {
          const response = await adminRequest.post(
            `${BASE_URL}/course/getSemestersById`,
            {
              id: formData.program,
            },
          );
          setSemester(response.data.data);
        } catch (error) {
          console.log(error);
        }
      };
      fetchSemester();
    }
    fetchProgram();
  }, [formData.program]);

  useEffect(() => {
    if (formData.semester) {
      const fetchSubject = async () => {
        try {
          const response = await adminRequest.post(
            `${BASE_URL}/course/curriculum/subjects`,
            {
              id: formData.semester,
            },
          );
          setSubject(response.data.data);
        } catch (error) {
          console.log(error);
        }
      };
      fetchSubject();
    }
  }, [formData.semester]);

  useEffect(() => {
    const fetchFaculty = async () => {
      try {
        const response = await adminRequest.get(
          `${BASE_URL}/faculty/getNameAndId`,
        );
        setFaculty(response.data.faculties);
      } catch (error) {
        console.log(error);
      }
    };
    fetchFaculty();
  }, []);

  useEffect(() => {
    const fetchTimeSlots = async () => {
      try {
        const response = await adminRequest.get(`${BASE_URL}/timeSlot/list`);
        setTimeSlots(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchTimeSlots();
  }, []);

  useEffect(() => {
    const fetchRoutine = async () => {
      try {
        const response = await adminRequest.post(`${BASE_URL}/routine/view`, {
          uuid: `${activeURL}`,
        });

        setData(response.data);
        setFormData({
          subject: response.data.data.subject,
          program: response.data.data.program,
          semester: response.data.data.semester,
          day: response.data.data.day,
          timeSlotId: response.data.data.timeSlotId,
          room: response.data.data.room,
          facultyId: response.data.data.facultyId,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchRoutine();
  }, [activeURL]);

  if (!data || !data.data) {
    return <Loader />;
  }
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await toast.promise(
        adminRequest.post(`${BASE_URL}/routine/update`, {
          uuid: activeURL,
          subject: formData.subject,
          program: formData.program,
          semester: formData.semester,
          day: formData.day,
          timeSlotId: formData.timeSlotId,
          room: formData.room,
          facultyId: formData.facultyId,
        }),
        {
          pending: "Updating Routine",
        },
      );

      toast.success(response.data.message, {
        autoClose: 500,
        onClose: () => navigate(-1),
      });

      setFormData(initialFormData);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setIsSubmitting(false);
    }
  };
  const fields = [
    {
      name: "program",
      label: "Course",
      type: "select",
      value: formData.program,
      onChange: handleChange,
      options: [
        { label: "Select Course", value: "" },
        ...program.map((p) => ({
          label: p.short_name,
          value: p.id,
        })),
      ],
    },
    {
      name: "semester",
      label: "Semester",
      type: "select",
      value: formData.semester,
      onChange: handleChange,
      options: [
        { label: "Select Semester", value: "" },
        ...semester.map((semester) => ({
          label: semester.semester,
          value: semester.id,
        })),
      ],
    },
    {
      name: "subject",
      label: "Subject",
      type: "text",
      value: formData.subject,
      onChange: handleChange,
    },
    {
      name: "day",
      label: "Day",
      type: "select",
      options: [
        { value: "", label: "Select Day" },
        { value: "SUNDAY", label: "Sunday" },
        { value: "MONDAY", label: "Monday" },
        { value: "TUESDAY", label: "Tuesday" },
        { value: "WEDNESDAY", label: "Wednesday" },
        { value: "THURSDAY", label: "Thursday" },
        { value: "FRIDAY", label: "Friday" },
      ],
      value: formData.day,
      onChange: handleChange,
    },
    {
      name: "timeSlotId",
      label: "Time Slot",
      type: "select",
      value: formData.timeSlotId,
      onChange: handleChange,
      options: [
        { label: "Select Time Slot", value: "" },
        ...timeSlots.map((option) => ({
          label: `${option.startTime} - ${option.endTime}`,
          value: option.id,
        })),
      ],
    },

    {
      name: "room",
      label: "Room",
      type: "text",
      value: formData.room,
      onChange: handleChange,
    },
    {
      name: "facultyId",
      label: "Faculty",
      type: "select",
      value: formData.facultyId,
      onChange: handleChange,
      options: [
        { label: "Select Faculty", value: "" },
        ...faculty.map((f) => ({
          label: f.name,
          value: f.id,
        })),
      ],
    },
  ];
  return (
    <div className="editRoutineContainer">
      <CustomForm
        header="Edit Routine"
        fields={fields}
        flexDirection="row"
        createButtonLabel="Update"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      <ToastContainer position="top-center" />
    </div>
  );
};

export default EditRoutine;
